export default {
  toggleMenu (state) {
    state.env.menu = !state.env.menu
  },
  switchLang (state, payload) {
    state.lang = payload
  },
  setApiBase (state, payload) {
    state.env.api_base = payload
  },
  setApiSecret (state, payload) {
    state.env.api_secret = payload
  },
  setApiID (state, payload) {
    state.env.api_id = payload
  },
  setToken (state, payload) {
    state.env.api_token = payload
    state.user.isLoggedIn = true
  },
  setUser (state, payload) {
    state.user.name = payload.name
    state.user.email = payload.email
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js